export default function stripTrackingParams (params) {
  // when parameters are changed, also make change in varnish VCL
  const stripParams = [
    'fbclid',
    'srsltid',
    'wbraid',
    'gbraid',
    'gclid',
    'gad_source',
    'gad_campaignid',
    'utm_source',
    'utm_campaign',
    'utm_medium',
    'utm_content',
    'utm_term',
    'utm_id',
    'mc_cid',
    'mc_eid',
    'confirmation_token',
    'confirmationAccessToken',
    'c'
  ]
  const newParams = Object.assign({}, params)
  stripParams.forEach(key => {
    if (newParams[key]) {
      delete newParams[key]
    }
  })

  return newParams
}
